import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F163jSchdADataRefreshService {

  constructor(private http: HttpClient) { }

  // CRITICAL: Service method signature following F7004 pattern
  refreshSchdAData(
    baseUrl: string,
    json_arrOBJ: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = baseUrl + "/saveJsonObject?action_id=31780";

    // CRITICAL: Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Add the JSON object data
    params = _.extend({
      jsonObj: JSON.stringify(json_arrOBJ)
    }, params);

    // Include checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID,
      "cdr_number": rowData.CDR_NO || rowData.TAX_CODE,
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY),
      "reporting_period": String(rowData.REPORTING_PERIOD),
      "combination_key": String(rowData.COMBINATION_KEY),
      "scenario_key": parseInt(filterParams.scenario || 74)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add other required fields from rowData
    if (rowData.CONSOL_GROUP_KEY) {
      params.filing_key = rowData.CONSOL_GROUP_KEY;
    }

    // MUST use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
